import { device_px, primary, secondary } from "@/styles/variable"
import styled from "styled-components"

export const ChipRoot = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0 13px;
  height: 40px;
  max-width: 100%;

  color: ${primary.white};
  background-color: transparent;

  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.48px;
  cursor: pointer;

  .label {
    transform: translateY(1px);
  }

  &.chip-btn {
    user-select: none;
    cursor: pointer;
  }

  &.filled {
    border-color: #3d3d3d;
    background-color: #3d3d3d;
  }

  &.small {
    padding: 0 9px;
    height: 25px;

    font-size: 10px;
    font-weight: 500;
    letter-spacing: -0.3px;

    .label {
      transform: unset;
    }

    .icon {
      margin-right: 4px;
      width: auto;
      height: 10px;
      object-fit: contain;
    }
  }

  &.medium {
    padding: 0 11px;
    height: 30px;

    font-size: 12px;
    font-weight: 500;
    letter-spacing: -0.36px;

    .label {
      transform: unset;
    }

    .icon {
      margin-right: 5px;
      height: 13px;
      width: auto;
      object-fit: contain;
    }
  }

  .icon {
    margin-right: 8px;
    width: auto;
    height: 18px;
    object-fit: contain;
  }

  .label {
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

export const TimerChipRoot = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 40px;
  border: none;
  padding: 8px 16px;
  max-width: 100%;

  color: ${secondary.text};
  background-color: ${primary.black};

  font-size: 14px;
  font-weight: 900;
  line-height: normal;

  user-select: none;
  cursor: pointer;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
    width: 14px;
    height: 14px;
  }

  .label {
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media only screen and (max-width: ${device_px.MAX_1279}) {
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.3px;

    .icon {
      margin-right: 4px;
      width: 10px;
      height: 10px;
    }
  }
`

export const ChipContainerRoot = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  @media only screen and (max-width: ${device_px.MAX_1279}) {
    gap: 6px;
  }
`
